import React from 'react';
import {FileTypeFilter} from './FileTypeFilter';
import {IWithDisabled} from 'models/common';

export const FileTypeFilterMulti = ({disabled}: IWithDisabled) => {
  return <FileTypeFilter selectionType="multi" disabled={disabled} />;
};
